import { triggerSimpleAjax } from '../../helpers/httpHelper';
import { GET_OUTLETS } from '../../helpers/constants/apiUrl';

export default function getOutlets(req = '', workflowBased, isStatus) {
    if (req.includes('?show_only_special_action_states=false')) {
        req = req.replace('?show_only_special_action_states=false', '');
    } else if (req.includes('&show_only_special_action_states=false')) {
        req = req.replace('&show_only_special_action_states=false', '');
    }

    let reqString = workflowBased ? `?workflow_based=true${req.replace('?', '&')}` : req;

    // Extract all existing status values
    const statusMatches = reqString.match(/[?&]status=([^&]*)/g);
    let existingStatuses = statusMatches ? statusMatches.map(match => match.split('=')[1]) : [];


    if (isStatus) {
        if (existingStatuses.length === 0) {
            // Default to `active` if no status is found
            existingStatuses.push('active');
        } else if (!existingStatuses.includes('active') && !existingStatuses.includes('inactive')) {
            // Ensure only valid statuses are included
            existingStatuses = ['active'];
        }
    }

    // Remove any existing status parameters and append the correct values
    reqString = reqString.replace(/[?&]status=[^&]*/g, '');
    if (existingStatuses.length > 0) {
        reqString += `&status=${existingStatuses.join('&status=')}`;
    }

    // Ensure `include_temp=yes` is always included
    if (!reqString.includes('include_temp=yes')) {
        reqString += `&include_temp=yes`;
    }

    // Map legacy `outlet_is_unicorn` parameter to `is_unicorn`
    reqString = reqString.replace(/([?&])outlet_is_unicorn=([^&]*)/g, '$1is_unicorn=$2');

    
    let url = `${GET_OUTLETS}${reqString}`.replace("/&","/?" ) 

    return new Promise((res, rej) => {
        triggerSimpleAjax(
            `${url}`,
            'GET',
            {},
            (response) => {
                res(response);
            },
            (error) => {
                rej(error);
            }
        );
    });
}
